import { PaiLensSourceDescription } from '@upright/ui/common/upright/core/impact-lenses/pais/source-description';
import { PaiLensSourceDescriptionTooltip } from '@upright/ui/common/upright/core/impact-lenses/pais/source-description/tooltip';
import { KBUrl, TooltipReadMoreKbLink } from '@upright/ui/common/upright/kb-urls';

export const paiLensTexts = {
  SourceDescription: PaiLensSourceDescription,
  SourceTooltipContent: PaiLensSourceDescriptionTooltip,
  LensTitle: () => <>EU SFDR PAIs</>,
  LensDescription: () => <>Principal Adverse Impacts from EU SFDR</>,
  LensTooltipContent: () => (
    <>
      Indicators for Principal Adverse Impacts from the EU Sustainable Finance Disclosure Regulation (SFDR). Upright
      currently covers all the mandatory PAI indicators defined in the regulation.
      <TooltipReadMoreKbLink href={KBUrl.METRICS_PAIS} />
    </>
  ),
};
